import { useAppSelector } from "@app/hooks";
import { OrganizationStatus } from "@helpers/organizationHelper";
import { useUserPermission } from "@helpers/userPermissionHelper";
import { NavItems } from "../../../../../common/helpers/navigation";
import { AdminNavItem } from "../../../components/manageNavItem";
import { getEnumKeyByValue } from "@helpers/enumHelper";

export const ManageNav = (): JSX.Element => {
    const staffCount = useAppSelector((x) => x.organization.activeStaffUsers);
    const locationExamineesCount = useAppSelector((x) => x.orgLocations.examineesCount);
    const organization = useAppSelector((x) => x.organization);
    const { isClinicalAdmin, isFacilitator } = useUserPermission({ useCurrentLocation: true });

    const renderNav = (): JSX.Element => {
        const navItems: any[] = [];

        if (isClinicalAdmin || isFacilitator) {
            navItems.push({ item: NavItems.Admin.Manage.Overview });
            navItems.push({ item: NavItems.Admin.Manage.Staff, itemCount: staffCount });
            navItems.push({ item: NavItems.Admin.Manage.Examinees, itemCount: locationExamineesCount });
        }

        if (
            isClinicalAdmin &&
            (organization.status as string) === getEnumKeyByValue(OrganizationStatus, OrganizationStatus.active)
        ) {
            navItems.push({ item: NavItems.Admin.Manage.RolesAndPermissions });
        }

        return (
            <ul>
                {navItems.map((x, i) => (
                    <AdminNavItem key={`manage-nav-item-${i}`} item={x.item} itemCount={x.itemCount} />
                ))}
            </ul>
        );
    };

    return (
        <div className="tabs is-boxed px-5 has-background-primary-dark is-size-7 has-text-weight-medium">
            {renderNav()}
        </div>
    );
};
